import { pipe, Option, Array as A } from 'effect';
import { z } from 'zod';

// Not narrowed to the fields the form renders: the save posts every field back, rendered or not.
export const ErpPreferenceFieldsResponseSchema = z.array(
  z.looseObject({ name: z.string(), type: z.string(), value: z.unknown() }),
);

export type ErpPreferenceFieldsResponse = z.infer<typeof ErpPreferenceFieldsResponseSchema>;

export const ERP_FIELD_TYPES = [
  'boolean',
  'int',
  'float',
  'text',
  'list',
  'dynamic_list',
  'file',
  'ftp_connection',
  'priority_customer_api_connection',
  'indexes_sync_time',
] as const;

export type ErpFieldType = (typeof ERP_FIELD_TYPES)[number] | 'unknown';

// A type this frontend cannot render yet reads as 'unknown': the field is left out, the rest of the form renders.
export const erpFieldType = (type: string): ErpFieldType =>
  pipe(
    A.findFirst(ERP_FIELD_TYPES, (known) => known === type),
    Option.getOrElse(() => 'unknown' as const),
  );

export const ErpPreferencesSaveBodySchema = z.object({
  config: z.record(z.string(), z.unknown()),
  erp_type: z.string(),
  propagate_fields: z.array(z.string()).optional(),
  propagate_to_companies: z.array(z.string()).optional(),
  should_copy_custom_fields_list: z.boolean().optional(),
});

export type ErpPreferencesSaveBody = z.infer<typeof ErpPreferencesSaveBodySchema>;
